import * as angular from 'angular';
import {LogisticsVehicle} from "../models/logistics-vehicle.model";
import {Document} from "../../commons/models/document.model";
import {ReminderSettings} from "../../site-preferences/models/reminder-settings.model";
import {Reminder} from "../../commons/models/reminder.model";
import {LogisticsVehicleRequestsService} from "./logistics-vehicle-requests.service";
import {LogisticsVehicleExportQueryModel} from "../models/logistics-vehicle-export-query.model";
import {IQService} from "angular";
import {BringozLoaderService} from "../../commons/services/bringoz-loader.service";
import {LogisticsVehiclesAlertsService} from "./logistics-vehicles-alerts.service";

export class LogisticsVehicleService {

  constructor(private $q: IQService, private bringozLoaderService: BringozLoaderService, private logisticsVehicleRequestsService: LogisticsVehicleRequestsService,
              private logisticsVehiclesAlertsService: LogisticsVehiclesAlertsService, private $log) {
  }

  getMany(ids) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.logisticsVehicleRequestsService.getMany(ids)
      .then((logisticsVehicles: LogisticsVehicle[]) => {
        deferred.resolve(logisticsVehicles);
      })
      .catch((error) => {
        this.$log.error(error);
        // this.logisticsVehiclesAlertsService.createError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  createLogisticsVehicle(logisticsVehicle: LogisticsVehicle) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.logisticsVehicleRequestsService.createOne(logisticsVehicle)
      .then((createdLogisticsVehicle) => {
        this.logisticsVehiclesAlertsService.createSuccess();
        deferred.resolve(createdLogisticsVehicle);
      })
      .catch((error) => {
        this.$log.error(error);
        this.logisticsVehiclesAlertsService.createError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  updateLogisticsVehicle(logisticsVehicle: LogisticsVehicle) {
    const deferred = this.$q.defer<LogisticsVehicle>();

    this.bringozLoaderService.on();
    this.logisticsVehicleRequestsService.updateOne(logisticsVehicle)
      .then((updatedLogisticsVehicle) => {
        this.logisticsVehiclesAlertsService.updateSuccess();
        deferred.resolve(updatedLogisticsVehicle);
      })
      .catch((error) => {
        this.$log.error(error);
        this.logisticsVehiclesAlertsService.updateError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  //////////////////////////////////////// DOCUMENTS ////////////////////////////////////////

  getDocuments(logisticsVehicleId: string) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.logisticsVehicleRequestsService.getDocuments(logisticsVehicleId)
      .then((documents: Document[]) => {
        deferred.resolve(documents);
      })
      .catch((error) => {
        this.$log.error(error);
        this.logisticsVehiclesAlertsService.getDocumentsError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  createDocument(document: any, vehicleId) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.logisticsVehicleRequestsService.createDocument(document, vehicleId)
      .then((createdDocument: Document) => {
        this.logisticsVehiclesAlertsService.createDocumentSuccess();
        deferred.resolve(createdDocument);
      })
      .catch((error) => {
        this.$log.error(error);
        this.logisticsVehiclesAlertsService.createDocumentError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  updateDocument(document: Document, vehicleId: string) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.logisticsVehicleRequestsService.updateDocument(document, vehicleId)
      .then((document: Document) => {
        this.logisticsVehiclesAlertsService.updateDocumentSuccess();
        deferred.resolve(document);
      })
      .catch((error) => {
        this.$log.error(error);
        this.logisticsVehiclesAlertsService.updateDocumentError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  deleteDocument(documentId: string, vehicleId: string) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.logisticsVehicleRequestsService.deleteDocument(documentId, vehicleId)
      .then(() => {
        this.logisticsVehiclesAlertsService.deleteDocumentSuccess();
        deferred.resolve();
      })
      .catch((error) => {
        this.$log.error(error);
        this.logisticsVehiclesAlertsService.deleteDocumentError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });
    return deferred.promise;
  }

  //////////////////////////////////////// REMINDERS ////////////////////////////////////////

  getReminders(logisticsVehicleId: string) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.logisticsVehicleRequestsService.getReminders(logisticsVehicleId)
      .then((reminders: ReminderSettings[]) => {
        deferred.resolve(reminders);
      })
      .catch((error) => {
        this.$log.error(error);
        this.logisticsVehiclesAlertsService.getRemindersError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  createReminder(reminder: Reminder, vehicleId) {
    const deferred = this.$q.defer<any>();

    this.bringozLoaderService.on();
    this.logisticsVehicleRequestsService.createReminder(reminder, vehicleId)
      .then((createdReminder: Reminder) => {
        this.logisticsVehiclesAlertsService.createReminderSuccess();
        deferred.resolve(createdReminder);
      })
      .catch((error) => {
        this.$log.error(error);
        this.logisticsVehiclesAlertsService.createReminderError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  updateReminder(reminder: Reminder, vehicleId: string) {
    const deferred = this.$q.defer<any>();

    this.bringozLoaderService.on();
    this.logisticsVehicleRequestsService.updateReminder(reminder, vehicleId)
      .then((updatedReminder: Reminder) => {
        this.logisticsVehiclesAlertsService.updateReminderSuccess();
        deferred.resolve(updatedReminder);
      })
      .catch((error) => {
        this.$log.error(error);
        this.logisticsVehiclesAlertsService.updateReminderError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  deleteReminder(reminderId: string, vehicleId: string) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.logisticsVehicleRequestsService.deleteReminder(reminderId, vehicleId)
      .then(() => {
        this.logisticsVehiclesAlertsService.deleteReminderSuccess();
        deferred.resolve();
      })
      .catch((error) => {
        this.$log.error(error);
        this.logisticsVehiclesAlertsService.deleteReminderError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  //////////////////////////////////////// BINDINGS ////////////////////////////////////////

  bindToAgent(agentId: string, logisticsVehicleIds: string[], forceUnbind?) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.logisticsVehicleRequestsService.bindToAgent(agentId, logisticsVehicleIds, forceUnbind)
      .then((res) => {
        this.logisticsVehiclesAlertsService.bindToAgentSuccess();
        deferred.resolve(res);
      })
      .catch((error) => {
        this.$log.error(error);
        this.logisticsVehiclesAlertsService.bindToAgentError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  unbindVehicle(agentId: string) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.logisticsVehicleRequestsService.unbindVehicle(agentId)
      .then((res) => {
        this.logisticsVehiclesAlertsService.unbindVehicleSuccess();
        deferred.resolve(res);
      })
      .catch((error) => {
        this.$log.error(error);
        this.logisticsVehiclesAlertsService.unbindVehicleError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  getCurrentBoundedByAgent(agentId: string): angular.IPromise<LogisticsVehicle[]> {
    const deferred = this.$q.defer<any>();

    this.bringozLoaderService.on();
    this.logisticsVehicleRequestsService.getCurrentBoundedByAgent(agentId)
      .then((res) => {
        deferred.resolve(res);
      })
      .catch((error) => {
        this.$log.error(error);
        this.logisticsVehiclesAlertsService.bindToAgentError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  exportLogisticsVehicles(query: LogisticsVehicleExportQueryModel) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.logisticsVehicleRequestsService.exportLogisticsVehicles(query)
      .then((data) => {
        this.logisticsVehiclesAlertsService.exportVehiclesSuccess();
        deferred.resolve(data);
      })
      .catch((error) => {
        this.$log.error(error);
        this.logisticsVehiclesAlertsService.exportVehiclesError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  deleteLogisticsVehicles(logisticVehicleId: string) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.logisticsVehicleRequestsService.deleteLogisticsVehicles(logisticVehicleId)
      .then((data) => {
        this.logisticsVehiclesAlertsService.deleteVehicleSuccess();
        deferred.resolve(data);
      })
      .catch((error) => {
        this.$log.error(error);
        this.logisticsVehiclesAlertsService.deleteVehicleError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  getVehicleResources(logisticVehicleId: string) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.logisticsVehicleRequestsService.getVehicleResources(logisticVehicleId)
      .then((data) => {
        deferred.resolve(data);
      })
      .catch((error) => {
        this.$log.error(error);
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }


}

angular
  .module('bringoz.admin.logistics-vehicle')
  .service('logisticsVehicleService', LogisticsVehicleService);

